/**
 * un objet fonction utilisé dans les pivots pour générer les aggrégats
 */
export class PivotFunction {
  public code: string; // le code unique de la fonction
  public label: string; // le libellé intelligible
  public description: string; // une desc éventuelle

  public forNum: boolean = false; // valable pour les numériques
  public forDate: boolean = false; // valable pour les dates
  public forString: boolean = false; // valable pour les strings
  public forBoolean: boolean = false; // valable pour les strings
  public forColor: boolean = false; // valable pour les couleurs

  public dataKind: string = null; // format de donnée retourné. Si null, c'est le format de la mesure d'origine

  public get fullName(): string {
    return this.code + ' - ' + this.label;
  }

  /**
   *
   * @param code le code unique de la fonction
   * @param label le libellé intelligible
   * @param description une desc éventuelle
   * @param forNum valable pour les numériques
   * @param forDate valable pour les dates et times
   * @param forString valable pour les strings
   * @param forBoolean valable pour les bools
   * @param forColor valable pour les couleurs
   * @param dataKind format de donnée retourné, si null, c'est le format de la donnée d'origine
   */
  constructor(
    code: string,
    label: string,
    description: string = null,
    forNum: boolean = false,
    forDate: boolean = false,
    forString: boolean = false,
    forBoolean: boolean = false,
    forColor: boolean = false,
    dataKind: string = null
  ) {
    this.code = code;
    this.label = label;
    this.description = description;
    this.forNum = forNum;
    this.forDate = forDate;
    this.forString = forString;
    this.forBoolean = forBoolean;
    this.forColor = forColor;
    this.dataKind = dataKind;
  }
}
